import React from "react";
import { StyledButton, StyledHCard, StyledService } from "../components/Styles";

import Visibility2 from "../components/Styles/assets/Graphics/Visibility2.webp";
import OrganicTraffic from "../components/Styles/assets/Graphics/OrganicTraffic.webp";
import CostEffective from "../components/Styles/assets/Graphics/CostEffective.webp";
import Experience from "../components/Styles/assets/Graphics/Experience.webp";
import Credibility from "../components/Styles/assets/Graphics/Credibility.webp";
import Growth from "../components/Styles/assets/Graphics/Growth.webp";
import LocalSEO from "../components/Styles/assets/Graphics/LocalSEO.webp";
import Competitive from "../components/Styles/assets/Graphics/Competitive.webp";

import img14 from "../components/Styles/assets/img14.webp";
import { Link } from "react-router-dom";
import Consultation from "../components/Consultation";

import { useTranslation } from "react-i18next";
import { slugs } from "../config/slugs";

function Seo() {
  const { i18n, t } = useTranslation();

  const advantages = [
    "visibility",
    "organicTraffic",
    "costEffective",
    "experience",
    "credibility",
    "growth",
    "localSEO",
    "competitive"
  ];

  const icons = {
    visibility: Visibility2,
    organicTraffic: OrganicTraffic,
    costEffective: CostEffective,
    experience: Experience,
    credibility: Credibility,
    growth: Growth,
    localSEO: LocalSEO,
    competitive: Competitive
  };

  return (
    <StyledService.Container>
      <StyledService.Hero>
        <StyledService.Content>
          <StyledService.Title lang={i18n.language}>{t("seo.title")}</StyledService.Title>
          <StyledService.Description>
            {t("seo.description")}
          </StyledService.Description>
          <Link to={`/${i18n.language}/${slugs.contact[i18n.language]}`}>
            <StyledButton.Main>{t("seo.cta")}</StyledButton.Main>
          </Link>
        </StyledService.Content>
        <StyledService.ImageContainer>
          <img
            src={img14}
            alt={t("seo.title")}
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
        </StyledService.ImageContainer>
      </StyledService.Hero>

      <Consultation />

      <StyledService.H3 lang={i18n.language}>{t("seo.advantagesTitle")}</StyledService.H3>

      <StyledHCard.Container>
        {advantages.map((key) => (
          <StyledHCard.SingleCard key={key}>
            <StyledHCard.IconContainer>
              <img src={icons[key]} alt={key} />
            </StyledHCard.IconContainer>
            <StyledHCard.Content>
              <StyledHCard.Title>
                {t(`seo.advantages.${key}.title`)}
              </StyledHCard.Title>
              <StyledHCard.Description>
                {t(`seo.advantages.${key}.desc`)}
              </StyledHCard.Description>
            </StyledHCard.Content>
          </StyledHCard.SingleCard>
        ))}
      </StyledHCard.Container>
      <Consultation />
    </StyledService.Container>
  );
}

export default Seo;